import { OfferPageFormDataWithName } from '@features/Funnel/screens/FunnelPage/OfferPage/OfferPageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { offerPayloadFactory } from '../../utils/offerFunnelsPagesFactory';

interface UpdateOfferFunnelPageRequest {
  id: string;
  payload: OfferPageFormDataWithName;
}

export function useTryToRequestUpdateOfferPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ id, payload }: UpdateOfferFunnelPageRequest) => {
      const factory = await offerPayloadFactory(payload);

      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        factory
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Oferta',
        'Ocorreu um erro ao editar o funil de Oferta, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestUpdateOfferPage: mutateAsync,
    isLoadingUpdateOffer: isPending,
  };
}
